import * as React from "react";

interface Props {
  isBadgeShowing: boolean;
}

const EmptyReportsTable: React.FC<Props> = ({ isBadgeShowing }) => {
  return (
    <div
      className="loading-container"
      style={{ height: isBadgeShowing ? "50vh" : "58.8vh" }}
    >
      <h3>No Reports Available...</h3>
      <p>Please try changing your filters criteria.</p>
    </div>
  );
};

export default EmptyReportsTable;
